import React, { useState } from 'react';

import { cssMap } from '@atlaskit/css';
import ChevronDownIcon from '@atlaskit/icon/core/chevron-down';
import ChevronRightIcon from '@atlaskit/icon/core/chevron-right';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import { Pressable } from '@atlaskit/primitives/compiled/pressable';
import { Text } from '@atlaskit/primitives/compiled/text';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	trigger: {
		width: '100%',
		backgroundColor: 'transparent',
		paddingInline: '0',
	},
	content: {
		paddingBottom: token('space.200'),
	},
});

interface ExpandableSectionProps {
	title: string;
	children: React.ReactNode;
	defaultExpanded?: boolean;
	testId?: string;
	onClick?: () => void;
}

export function ExpandableSection({
	title,
	children,
	defaultExpanded = false,
	testId,
	onClick,
}: ExpandableSectionProps): React.JSX.Element {
	const [isExpanded, setIsExpanded] = useState(defaultExpanded);
	const ChevronIcon = isExpanded ? ChevronDownIcon : ChevronRightIcon;

	return (
		<Box testId={testId}>
			<Pressable
				xcss={styles.trigger}
				onClick={() => {
					setIsExpanded(!isExpanded);
					onClick?.();
				}}
				aria-expanded={isExpanded}
				testId={testId ? `${testId}-trigger` : undefined}
			>
				<Inline spread="space-between" alignBlock="center">
					<Text weight="medium" color="color.text">
						{title}
					</Text>
					<ChevronIcon label="" color="currentColor" />
				</Inline>
			</Pressable>
			{isExpanded && <Box xcss={styles.content}>{children}</Box>}
		</Box>
	);
}
